module.exports = __webpack_public_path__ + "img/34b-config-modelos-doc-wizard-confirmar.32893f17.png";